import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WarningModalMessage } from '../interfaces/warning-modal-message.interface';
import { WarningModalContext } from '../enums/warning-modal-context.enum';
import { DateHelper } from '../helpers/datehelper';

@Injectable({
	providedIn: 'root',
})
export class WarningModalMessageService {
	url: string = 'warningModalMessage';

	constructor(private http: HttpClient) {}

	public getWarningModalMessages() {
		return this.http.get<WarningModalMessage[]>(`${this.url}/GetWarningModalMessages`);
	}

	public getWarningModalMessagesForLink(linkId: number, context: WarningModalContext) {
		return this.http.get<WarningModalMessage[]>(`${this.url}/GetWarningModalMessagesForLink/${linkId}/${context}`);
	}

	public clearMessageLinks(linkId: number) {
		return this.http.get(`${this.url}/ClearMessageLinks/${linkId}`);
	}

	public setKeepShowing(linkId: number, messageId: number, keepShowing: boolean) {
		return this.http.get(`${this.url}/SetKeepShowing/${linkId}/${messageId}/${keepShowing}`);
	}

	public deleteWarningModalMessage(id: number) {
		return this.http.delete(`${this.url}/DeleteWarningModalMessage/${id}`);
	}

	public createWarningModalMessage(createDto: WarningModalMessage) {
		return this.http.post(`${this.url}/CreateWarningModalMessage`, DateHelper.withConvertedDates(createDto));
	}

	public updateWarningModalMessage(updateDto: WarningModalMessage) {
		return this.http.post(`${this.url}/UpdateWarningModalMessage`, DateHelper.withConvertedDates(updateDto));
	}
}
